"use client";

import { Separator } from "@/components/ui/separator";
export default function StrategicPartners() {
  const partners = [{
    name: "Laboratorio Cominotti",
    industry: "Design Lab",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_cominotti.png"
  }, {
    name: "AcquaViva",
    industry: "Beverage",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_acquaviva.png"
  }, {
    name: "Idea!",
    industry: "Marketing",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_idea.png"
  }, {
    name: "PNGroup",
    industry: "Consulting",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_pngroup.png"
  }, {
    name: "SpiderNode",
    industry: "Technology",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_spidernode.png"
  }, {
    name: "Vogue",
    industry: "Fashion",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_vogue.png"
  }, {
    name: "Accademia di Belle Arti SantaGiulia",
    industry: "Education",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_santagiulia.png"
  }, {
    name: "Brescia Musei",
    industry: "Culture",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_bresciamusei.png"
  }, {
    name: "Smart Future Academy",
    industry: "Education",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_smartfuture.png"
  }, {
    name: "Confindustria",
    industry: "Association",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_confindustria.png"
  }, {
    name: "TechFlow",
    industry: "Software",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_techflow.png"
  }, {
    name: "Urban Studio",
    industry: "Architecture",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_urban_studio.png"
  }, {
    name: "Global Media",
    industry: "Broadcasting",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_global_media.png"
  }, {
    name: "Nexus Corp",
    industry: "Logistics",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/logo_nexus_corp.png"
  }];
  const loop = [...partners, ...partners];
  return <section data-section-id="1670" id="strategic-partners" className="bg-[#0a0a0a] text-white py-16 md:py-24 overflow-hidden">
      <div className="mx-auto max-w-[1280px] px-5 md:px-10 lg:px-16">
        
      </div>

      <style>{`
        @keyframes flowstate-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          animation: flowstate-marquee 50s linear infinite;
          width: max-content;
        }
        .group:hover .marquee-track {
          animation-play-state: paused;
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track {
            animation: none;
          }
        }
      `}</style>
    </section>;
}